import React from 'react';
import classnames from 'classnames';
import { IMaskMixin } from 'react-imask';
import LocalizedText from '@LocalizedText';
import './ResizeTool.scss';

const MaskedInput = IMaskMixin(({ inputRef, ...props }) => <input {...props} ref={inputRef} />);
const handleDragStart = e => {
  e.preventDefault();
  e.stopPropagation();
};

const ResizeInput = ({ side, values, errors, locale, handleChange, handleBlur, handleKeyPress, titleKey }) => {

  const fieldProps = {
    mask: Number,
    scale: values.unitScale,
    radix: '.',
    mapToRadix: [','],
    unmask: true,
    min: 0,
    max: 999999,
  };

  return (
    <>
      <div className={classnames('resize-tool-container', { invalid: errors[side] })}>
        <div className="resize-tool-wrapper">
          <div className="resize-tool-title"><LocalizedText id={titleKey} tagName="span"/></div>
          <div className={classnames('resize-tool', side, locale, { invalid: errors[side] })}>
            <MaskedInput
              {...fieldProps}
              name={side}
              id={`resize-tool-${side}`}
              value={JSON.stringify(values[side])}
              invalid={JSON.stringify(errors[side])}
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              onDragStart={handleDragStart}
            />
          </div>
        </div>
        <div className="resize-tool-invalid-label">
          <LocalizedText
            id={`qau-field-validation-${locale}`}
            values={{
              min: values.sideMin,
              max: values.sideMax,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ResizeInput;
